// Persistência de "linhas por página" agrupada em 3 buckets, escolha do
// Filipe (2026-05-13): TOP/GROUP/ANIMALS — todas as tabelas paginadas
// compartilham o mesmo storageKey dentro do seu bucket.
//
// TOP    — listagens-raiz e seleção de fazendas: Home, protocolos, usuários,
//          partidas/sêmen, touros, domínios admin, EstacaoDeMontaOtimizada.
//          Default 10. Usuário raramente precisa ver mais; renderizar 100
//          fazendas na Home é desnecessário.
// GROUP  — sub-entidades: retiros (dentro da fazenda), lotes (dentro do retiro).
//          Default 10.
// ANIMALS — listagem de matrizes (fluxos IATF: D0, DN, DG, IATF, Resync,
//           batches/animals). Default 50 — usuários tipicamente querem ver
//           tudo de uma vez.
//
// Adição de um novo bucket exige mudança aqui + atualização do consumidor.

export const TABLE_BUCKET = Object.freeze({
  TOP: 'top',
  GROUP: 'group',
  ANIMALS: 'animals',
})

const STORAGE_PREFIX = 'progerar.rowsPerPage'

const BUCKET_DEFAULTS = Object.freeze({
  [TABLE_BUCKET.TOP]: 10,
  [TABLE_BUCKET.GROUP]: 10,
  [TABLE_BUCKET.ANIMALS]: 50,
})

const FALLBACK_DEFAULT = 10

function storageKey(bucket) {
  return `${STORAGE_PREFIX}.${bucket}`
}

export function getBucketRowsPerPage(bucket, propFallback) {
  const safeBucket = bucket && BUCKET_DEFAULTS[bucket] != null ? bucket : TABLE_BUCKET.TOP
  try {
    const raw = localStorage.getItem(storageKey(safeBucket))
    const parsed = parseInt(raw, 10)
    if (Number.isFinite(parsed) && parsed > 0) return parsed
  } catch {
    // localStorage inacessível (ex.: SSR ou modo privado bloqueado) — segue p/ default
  }
  return BUCKET_DEFAULTS[safeBucket] ?? propFallback ?? FALLBACK_DEFAULT
}

export function setBucketRowsPerPage(bucket, value) {
  const safeBucket = bucket && BUCKET_DEFAULTS[bucket] != null ? bucket : TABLE_BUCKET.TOP
  try {
    localStorage.setItem(storageKey(safeBucket), String(value))
  } catch {
    // ignora falhas de persistência — estado em memória ainda funciona
  }
}
